export default __webpack_public_path__ + "images/D6.27366dd.png";